import {
    Dialog, DialogTitle, DialogContent, Typography, Button,
    TextField, Box, Checkbox, FormControlLabel, IconButton
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { TimePicker } from '@mui/x-date-pickers';
import { useState } from 'react';
import dayjs from 'dayjs';
import { useHttp } from '../../utils/useHttp';
import showToast from '../Hot-Toast/showToast';
import moment from 'moment';

const JobTimecardDetailsDialog = ({ open, onClose, data, onSave }) => {
    console.log("data", data);
    const [shiftIn, shiftOut] = data.ShiftTime.split(' - ');

    const [inTime, setInTime] = useState(dayjs(`2000-01-01 ${shiftIn}`));
    const [outTime, setOutTime] = useState(dayjs(`2000-01-01 ${shiftOut}`));
    const [lunchTime, setLunchTime] = useState(data?.JOB_LUNCH_TIME || 0);
    const [autoFill, setAutoFill] = useState(true);
    const api = useHttp({});

    const {
        shiftId = data.Temp,
        shiftDate = data.ShiftDate,
        clientConfirm = data.ApprovedDate,
        status = data.Status,
        modifiedBy = data.ReconciledBy,
        modifiedAt = data?.LAST_MODIFIED_DATE
    } = data || {};

    const handleSave = async () => {
        try {
            const payload = {
                id: data.id || data.Temp,
                shiftIn: inTime.format('HH:mm'),
                shiftOut: outTime.format('HH:mm'),
                shiftDate: shiftDate,
                lunchTime: lunchTime,
            };

            const response = await api.post('/job/timecardUpdate', payload);

            if (response.data.STATUS) {
                showToast('success', 'Timecard updated successfully');
                if (onSave) onSave(); // Callback to refresh parent data
                onClose();
            } else {
                showToast('error', response.data.MESSAGE || 'Failed to update timecard');
            }
        } catch (error) {
            console.error('Save error:', error);
            showToast('error', 'Failed to update timecard');
        }
    };

    return (
        <LocalizationProvider dateAdapter={AdapterDayjs}>
            <Dialog open={open} onClose={onClose} fullWidth maxWidth="sm">
                <DialogTitle>
                    <Typography variant="h4" color="green">Shift Timecard Details</Typography>
                    <IconButton
                        onClick={onClose}
                        sx={{ position: 'absolute', right: 8, top: 8 }}
                    >
                        <CloseIcon />
                    </IconButton>
                </DialogTitle>
                <DialogContent dividers>
                    <Box sx={{ mb: 2 }}>
                        <Typography variant="h6" color="green">{shiftId}</Typography>
                        <Typography><strong>Shift Date:</strong> {shiftDate}</Typography>
                        <Typography><strong>Shift Time:</strong> {shiftIn} - {shiftOut}</Typography>
                        <Typography><strong>Client Confirm:</strong> {clientConfirm}</Typography>
                        <Typography><strong>Status:</strong> <span style={{ color: 'green' }}>{status}</span></Typography>
                        <Typography><strong>Modified:</strong> {modifiedBy} <br /> {moment(modifiedAt).format('DD-MM-YYYY h:mm A')}</Typography>
                    </Box>

                    <Box>
                        <Typography variant="subtitle1" sx={{ mb: 2 }}>Time</Typography>
                        <Box display="flex" gap={2} flexWrap="wrap">
                            <TimePicker
                                label="In Time"
                                value={inTime}
                                onChange={setInTime}
                                renderInput={(params) => <TextField {...params} />}
                            />
                            <TimePicker
                                label="Out Time"
                                value={outTime}
                                onChange={setOutTime}
                                renderInput={(params) => <TextField {...params} />}
                            />
                            <TextField
                                label="Lunch Time"
                                type="number"
                                value={lunchTime}
                                onChange={(e) => setLunchTime(e.target.value)}
                                InputProps={{ endAdornment: <span>minutes</span> }}
                            />
                        </Box>
                    </Box>

                    <Box
                        sx={{
                            display: 'flex',
                            justifyContent: 'space-between',
                            alignItems: 'center',
                            mt: 2
                        }}
                    >
                        <FormControlLabel
                            control={
                                <Checkbox
                                    checked={autoFill}
                                    onChange={(e) => setAutoFill(e.target.checked)}
                                />
                            }
                            label="Auto Fill Empty In/Out Times With Shift Order Times."
                        />

                        <Button
                            variant="contained"
                            color="success"
                            onClick={handleSave}
                        >
                            Save
                        </Button>
                    </Box>
                </DialogContent>
            </Dialog>
        </LocalizationProvider>
    );
};

export default JobTimecardDetailsDialog;
